export const grey100 = '#f5f5f5';
export const grey200 = '#bdbdbd';
export const grey300 = '#212121';
export const paleGreen = '#E8FCEA';



// WEBPACK FOOTER //
// ./client/styles/colors.js